import { ROUTE_NAMES } from "@root/constants";
import { selectAdminSidebar } from "@root/store/selectors/admin/app";
import { updateSidebar } from "@root/store/slices/admin";
import { logout } from "@root/store/thunks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useMediaQ from "./useMediaQ";
import { useTranslation } from "react-i18next";
import { LogoutIcon } from "@root/assets/icons";
import { useGlobalContext } from "@root/context/global-context";
import { selectProfile } from "@root/store/selectors/entities";
import useCustomTheme from "./useCustomTheme";
import { adminGetProfile } from "@root/store/thunks/admin/auth";
import { OrganizationIcon } from "@root/assets/icons/organizationIcon";

function useSuperAdminSidebar() {
  const { pathname } = useLocation();
  const { isDarkTheme } = useCustomTheme();
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const isOpen: boolean = useSelector(selectAdminSidebar);
  const { md_900 } = useMediaQ();
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const profileData = useSelector(selectProfile);

  const setIsOpen = (value: boolean) => {
    dispatch(updateSidebar(value));
  };

  useEffect(() => {
    if (!md_900 && isOpen) {
      setIsOpen(false);
    }
    if (md_900) {
      setIsOpen(true);
    }
  }, [md_900]);

  useEffect(() => {
    dispatch(adminGetProfile({}));
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [pathname]);

  const sidebarItems = [
    {
      title: t("superAdmin.organizations"),
      icon: OrganizationIcon({ color: "#1250F9" }),
      activeIcon: OrganizationIcon({ color: "#1250F9" }),
      routes: [ROUTE_NAMES.SUPER_ADMIN_ORGANIZATIONS],
      onClick: () => navigate(ROUTE_NAMES.SUPER_ADMIN_ORGANIZATIONS),
    },
    {
      type: "hr",
      onClick: () => null,
    },
  ];

  const superAdminLogoutHandler: any = async () => {
    dispatch(logout({}));
    navigate(ROUTE_NAMES.HOME);
  };

  const menuItemsList = [
    {
      title: t("sideMenu.Logout"),
      icon: LogoutIcon({ rotate: "180deg" }),
      onClick: () => setLogoutPopup(true),
      routes: [],
    },
  ];

  return {
    sidebarItems,
    pathname,
    isOpen,
    setIsOpen,
    isDarkTheme,
    menuItemsList,
    logoutPopup,
    setLogoutPopup,
    md_900,
    profileData,
    superAdminLogoutHandler,
    isMenuOpen,
    setIsMenuOpen,
  };
}

export default useSuperAdminSidebar;
